import React from "react";

const Total = ({ total }) => {
  return (
    <div className="f2 tc br2 fw6 mv2 pa3 white bg-navy 0-95 shadow-5">
      Total: {total}
    </div>
  );
};

export default Total;
